import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Workable webhook settings interface
 */
export interface WorkableWebhookSettings {
  candidate_created: boolean;
  candidate_moved: boolean;
  candidate_deleted: boolean;
  enabled_stages?: string[];
  default_recruiter_id?: string | null;
}

/**
 * Workable webhook settings response
 */
export interface WorkableWebhookSettingsResponse {
  data: {
    webhook_settings: WorkableWebhookSettings;
    webhook_subscriptions: { [event: string]: string };
    webhook_events: string[];
  };
}

/**
 * Workable-specific service
 * Handles Workable ATS-specific features like webhook event configuration
 */
@Injectable({
  providedIn: 'root'
})
export class WorkableService {
  private readonly baseUrl = `${environment.SERVER_ENDPOINT}/api/workable`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Get current webhook settings for Workable integration
   */
  public getWebhookSettings(): Observable<WorkableWebhookSettingsResponse> {
    return this.http.get<WorkableWebhookSettingsResponse>(`${this.baseUrl}/webhook_settings`);
  }

  /**
   * Update webhook settings for Workable integration
   */
  public updateWebhookSettings(settings: WorkableWebhookSettings): Observable<any> {
    return this.http.put(`${this.baseUrl}/webhook_settings`, settings);
  }

  /**
   * Get recruiters for the hiring firm
   */
  public getRecruiters(): Observable<any> {
    return this.http.get(`${this.baseUrl}/recruiters`);
  }

  /**
   * Get unique stage names across all jobs in Workable account
   */
  public getStages(): Observable<{ data: { stages: string[] } }> {
    return this.http.get<{ data: { stages: string[] } }>(`${this.baseUrl}/stages`);
  }
}
